import { client } from '@api/client';

import {
	ICommissionDTO,
	TCommissionHistoryRecountDTO,
} from '@interfaces/organisation/dto/organisationsDTO';
import { TCommissionHistory } from '@interfaces/organisation/organisations';

import { URL } from './urls';

const { organizationProfile, commissionSettings } = URL;

export const getCommissionHistory = (id: string): Promise<TCommissionHistory> => {
	return client.get(`/${organizationProfile}/${id}/${commissionSettings}/history`);
};

export const setCommissionHistory = (dto: TCommissionHistoryRecountDTO): Promise<ICommissionDTO> => {
	const { id, ...rest } = dto;

	return client.post(`/${organizationProfile}/${id}/${commissionSettings}/set-commission`, { ...rest });
};
